import LogsList from "../../components/log/LogsList"

export const LogsPage = () => {

    return (
        <LogsList></LogsList>
    )
}